export const MSA_SUBDOMAINS = { MSA: 'msatemplate' } as const;
export type MsaSubdomain = (typeof MSA_SUBDOMAINS)[keyof typeof MSA_SUBDOMAINS];
